export default "__VITE_ASSET__CeKjtyjj__"